import styled from 'styled-components'

import type { Sponsor } from '~/features/event-info/types/event-info'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

type Props = {
  sponsorList: Sponsor[]
}

function Sponsor({ sponsorList }: Props) {
  const mainSponsors = sponsorList.filter(
    (sponsor) => sponsor.sponsor_type === 'M',
  )
  const supportingSponsors = sponsorList.filter(
    (sponsor) => sponsor.sponsor_type === 'S',
  )

  return (
    <Wrapper>
      <Title>주관 및 협력사 소개</Title>
      <SponsorSection>
        <SponsorInfo title="주최사 소개" sponsors={mainSponsors} />
      </SponsorSection>
      <SponsorSection>
        <SponsorInfo title="협력사 소개" sponsors={supportingSponsors} />
      </SponsorSection>
    </Wrapper>
  )
}

export default Sponsor

const SponsorInfo = ({
  title,
  sponsors,
}: {
  title: string
  sponsors: Sponsor[]
}) => (
  <InfoWrapper>
    <TagBox className="center">
      <Tag $size="md" $variant="gray">
        {title}
      </Tag>
    </TagBox>
    {sponsors.map((sponsor, index) => (
      <Row key={index}>
        <ImageWrapper>
          <Image
            src={sponsor.image_info.url}
            alt={`Sponsor Logo ${index + 1}`}
          />
        </ImageWrapper>
        <Description>{sponsor.sponsor_desc}</Description>
      </Row>
    ))}
  </InfoWrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px; /* Title과 SponsorSection의 gap 설정 */

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`

const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`

const SponsorSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px; /* SponsorSection끼리의 gap 설정 */
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px; /* TagBox와 Row의 gap 설정 */
`

const TagBox = styled.div`
  display: flex;
  gap: 20px;
  line-height: 25px;

  .desc {
    font-family: NanumSquareNeo-Regular, sans-serif;
  }

  &.center {
    align-items: center;

    @media ${theme.device.medium} {
      align-items: start;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 36px; /* Row 안의 두 열의 gap 설정 */
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`

const ImageWrapper = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 160px;
  height: 64px;
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
`

const Description = styled.div`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 16px;
  line-height: 1.5;
`
